import type { DriveStep } from 'driver.js';
import type { TFunction } from 'i18next';

export const createIdeasTourSteps = (t: TFunction): DriveStep[] => [
  {
    element: document.body,
    popover: {
      title: t('onboarding.ideas.welcome_title', 'Генерация идей'),
      description: t(
        'onboarding.ideas.welcome_desc',
        'Расскажите о вашей теме — мы сгенерируем идеи для выступления и концепцию.',
      ),
    },
  },
  {
    element: '[data-tour="idea-goal-grid"]',
    popover: {
      title: t('onboarding.ideas.goal_title', 'Цель выступления'),
      description: t(
        'onboarding.ideas.goal_desc',
        'Выберите формат: питч, конференция, воркшоп и т.д. Стиль речи адаптируется под цель.',
      ),
    },
  },
  {
    element: '[data-tour="idea-audience"]',
    popover: {
      title: t('onboarding.ideas.audience_title', 'Целевая аудитория'),
      description: t(
        'onboarding.ideas.audience_desc',
        'Укажите, для кого будет выступление — ИИ подберёт подходящий уровень сложности.',
      ),
    },
  },
  {
    element: '[data-tour="idea-audience-size"]',
    popover: {
      title: t('onboarding.ideas.audience_size_title', 'Размер аудитории'),
      description: t(
        'onboarding.ideas.audience_size_desc',
        'Введите примерное количество слушателей для калибровки темпа и глубины.',
      ),
    },
  },
  {
    element: '[data-tour="idea-skills"]',
    popover: {
      title: t('onboarding.ideas.skills_title', 'Ваши навыки'),
      description: t(
        'onboarding.ideas.skills_desc',
        'Расскажите о своём опыте и экспертизе — это поможет создать убедительный контент.',
      ),
    },
  },
  {
    element: '[data-tour="idea-knowledge-level"]',
    popover: {
      title: t('onboarding.ideas.knowledge_level_title', 'Уровень знаний аудитории'),
      description: t(
        'onboarding.ideas.knowledge_level_desc',
        'Выберите, насколько аудитория знакома с темой — от новичков до экспертов.',
      ),
    },
  },
];
